module.exports = __webpack_public_path__ + "img/53.571b3f0b.svg";